import styled from "@emotion/styled";
import { type FunctionComponent, useCallback } from "react";

import { useTrackImpressionEventByIntersection } from "shared/hooks";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { RecirculationWidgetImpressionEvent } from "scmp-app/components/tracking/google-analytics-4/types";
import type { subscriberContentInlinePlusWidgetContent$key } from "scmp-app/queries/__generated__/subscriberContentInlinePlusWidgetContent.graphql";

import { Container, Content, Header, StyledLogo, StyledSeparator, Title } from "./styles";
import { InlinePlusWidgetSubscriberContent } from "./subscriber-content";

export type Props = {
  articleIds: string[];
  reference: subscriberContentInlinePlusWidgetContent$key[];
};

const Component: FunctionComponent<Props> = ({ articleIds, reference }) => {
  const contents = () =>
    reference.map((reference_, key) => (
      <InlinePlusWidgetSubscriberContent key={key} reference={reference_} sequence={key + 1} />
    ));

  const impressionGA4Event = useCallback<() => RecirculationWidgetImpressionEvent>(
    () => ({
      action: "imp",
      category: "recirculation",
      customized_parameters: {
        list_of_articles: articleIds.join(","),
        page_type: "article",
        product: "plus",
        widget_name: "hard_link",
      },
      subcategory: "widget",
    }),
    [articleIds],
  );

  const { captureTrackImpressionEventTargetElement } =
    useTrackImpressionEventByIntersection<RecirculationWidgetImpressionEvent>({
      ga4TrackingHandler: sendGA4Tracking,
      getGa4Event: impressionGA4Event,
      options: { isSendGA4Tracking: true, shouldSendOnce: true },
    });

  return (
    <Container ref={captureTrackImpressionEventTargetElement}>
      <Header>
        <StyledLogo />
        <StyledSeparator />
        <Title>Want to know more? Read around this topic:</Title>
      </Header>
      <Content>{contents()}</Content>
    </Container>
  );
};

Component.displayName = "InlinePlusWidgetSubscriber";

export const InlinePlusWidgetSubscriber = styled(Component)``;
